import React, { useEffect, useState } from "react";
import { useRootSelector } from "~redux/hooks";
import type { EquipmentTemplateBodyProps } from "components/views/template/EquipmentTemplateMenu";
import type { ApproachCode } from "@poscon/shared-types";
import { isApproachCode } from "@poscon/shared-types";
import { aselFlightplanSelector } from "~redux/slices/aircraftSlice";

export const EquipmentAppServTemplate = ({ setReset, fp }: EquipmentTemplateBodyProps) => {
  const [appCategories, setAppCategories] = useState<ApproachCode[]>([]);

  const toggleCategory = (cat: ApproachCode) => {
    const appCats = [...appCategories];
    const index = appCats.indexOf(cat);
    if (index < 0) {
      setAppCategories([...appCats, cat]);
    } else {
      appCats.splice(index, 1);
      setAppCategories(appCats);
    }
  };

  useEffect(() => {
    const field10a = fp?.navigationCodes ?? [];

    const appCats = field10a.filter(isApproachCode);

    const reset = () => {
      setAppCategories(appCats);
    };

    setReset(reset);
    reset();
  }, [fp?.navigationCodes, setReset]);

  return null;
  // return (
  //   <div className={eqpStyles.titleRow}>
  //     <div className={clsx(eqpStyles.col, eqpStyles.m20)}>
  //       <EquipmentTemplateRow
  //         key="eqp-app-serv-L"
  //         buttonText="L"
  //         text="(ILS)"
  //         selected={appCategories.includes(ApproachCategory.L)}
  //         toggleSelect={() => toggleCategory(ApproachCategory.L)}
  //       />
  //       <EquipmentTemplateRow
  //         key="eqp-app-serv-K"
  //         buttonText="K"
  //         text="(MLS)"
  //         selected={appCategories.includes(ApproachCategory.K)}
  //         toggleSelect={() => toggleCategory(ApproachCategory.K)}
  //       />
  //       <EquipmentTemplateRow
  //         key="eqp-app-serv-A"
  //         buttonText="A"
  //         text="(GBAS)"
  //         selected={appCategories.includes(ApproachCategory.A)}
  //         toggleSelect={() => toggleCategory(ApproachCategory.A)}
  //       />
  //       <EquipmentTemplateRow
  //         key="eqp-app-serv-B"
  //         buttonText="B"
  //         text="(LPV)"
  //         selected={appCategories.includes(ApproachCategory.B)}
  //         toggleSelect={() => toggleCategory(ApproachCategory.B)}
  //       />
  //     </div>
  //     <div className={clsx(eqpStyles.col, eqpStyles.m16)}>
  //       <EquipmentTemplateRow
  //         key="eqp-app-serv-S"
  //         buttonText="S"
  //         text="(STANDARD)"
  //         selected={appCategories.includes(ApproachCategory.S)}
  //         toggleSelect={() => toggleCategory(ApproachCategory.S)}
  //       />
  //     </div>
  //   </div>
  // );
};
